<template>
  <div>
    <!-- Botão para abrir o modal -->
    <v-btn color="primary" @click="dialog = true">Abrir Modal</v-btn>

    <!-- Modal -->
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Salvar Arquivo</v-card-title>
        <v-card-text>
          Clique abaixo para salvar o arquivo.
          <br />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <a :href="fileLink" download>
            <v-btn color="success" text>
              Salvar Arquivo
            </v-btn>
          </a>
          <v-btn color="error" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      fileLink: "https://storage.googleapis.com/sistema-foz.appspot.com/generated-pdfs/313c816e-d9c6-4b1c-9320-bd900e0af421.pdf?GoogleAccessId=firebase-adminsdk-5h3rz%40sistema-foz.iam.gserviceaccount.com&Expires=1737701246&Signature=cV%2BZsz03XdxSp8%2BGPSpF6YfTNmajveoA02hn4ST7Y%2FWzJYLNrdEY0WmsrUdImBGDsYH6EJQpQfwYJTPaBD0YsZz9znFZ7gwts3cyaJ4Ux%2Fr6escl192RLEZKFtIqiW8kN6jphsjovRojfpXf4SEWaQYzbkt5LBCEu%2BptsgRl0DFYjLQuQySy4YlLPq6Cgebx3Ylgs9%2BuWzutxlhn25MA3ICLKjpzMyOVo3wnTsJbY9uAouV9Q3N7paGC27ouUsTRPPCHtvlK9jGj%2B4EkxQ9%2BDmT8alUeSbECJEXWAyKXSP09i7LxIn8cerPYKHz71QfnkljvTbH5fsUmQPTsOEgbhA%3D%3D&response-content-disposition=attachment%3B%20filename%3D%22HOSPITAL%20EVANGELICO%20-%20ROI%20GERAL.pdf%22", // Substitua pelo link do arquivo
    };
  },
};
</script>

<style scoped>
/* Você pode adicionar estilos personalizados aqui, se necessário */
</style>
